import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './http';
import './plugins/bootstrap-vue';
import './plugins/vuelidate';
import './plugins/vue-select';
import './plugins/vue-safe-html';
import './plugins/app';
import './assets/scss/app.scss';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
